export default "__VITE_ASSET__D$BmAVFr__"